import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import EdSwitch from '@/components/forms/EdSwitch'

interface DocumentsSectionProps {
  isReadOnly?: boolean;
}

const DocumentsSection = ({ isReadOnly = false }: DocumentsSectionProps) => {
  const { register, watch, setValue } = useFormContext();


  const items = [
    { id: '1', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '2', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '3', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '4', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '5', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '6', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '7', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '8', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '9', name: 'Carlo Trainao', role: 'Tutor di processo' },
    { id: '10', name: 'Carlo Trainao', role: 'Tutor di processo' },


  ];

  const selections = watch('attoriSelezionati') || {};
  const selectionsObbligatorio = watch('attoriSelezionatiObbligatorio') || {};



  return (
    <div className="flex flex-col gap-1">
      <span className="text-[20px] text-[#4F4F4F] font-bold mt-2">Documenti di fine corso</span>
      <div className="w-full ">
        {items.map((item, idx) => {
          const checked = !!selections?.[item.id];
          const mandatorio = !!selectionsObbligatorio?.[item.id];
          return (
            <div key={item.id} className={`flex items-center justify-between px-0 py-1.5 ${idx !== items.length - 1 ? 'border-b border-gray-200' : ''}`}>
              <div className="flex items-center gap-12">
                <span className="text-sm text-black min-w-[180px]">REGISTRO</span>
                <span className="text-sm text-[#6B7280]">AULA</span>
              </div>
              <div className="flex items-center gap-2">
                <EdSwitch
                  id={`attore-${item.id}`}
                  value={mandatorio}
                  onChange={() => setValue(`attoriSelezionatiObbligatorio.${item.id}`, !mandatorio, { shouldDirty: true })}
                  disabled={isReadOnly}
                />
                <span className={`text-sm ${mandatorio ? 'text-black' : 'text-gray-400'}`}>Obbligatorio</span>
              </div>
              <div className="flex items-center gap-2">
                <EdSwitch
                  id={`attore-${item.id}`}
                  value={checked}
                  onChange={() => setValue(`attoriSelezionati.${item.id}`, !checked, { shouldDirty: true })}
                  disabled={isReadOnly}
                />
                <span className={`text-sm ${checked ? 'text-black' : 'text-gray-400'}`}>Selezionato</span>
              </div>
            </div>
          );
        })}
      </div>
  
    </div>
  )
}

export default DocumentsSection